import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {CommonConstant} from '../../app.constants';
import {UserService} from '../../services/user.service';
import {InfluencerCampaignPost, InfluencerCampaignStatus} from '../../../models/influencer-campaign';
import {Title} from '@angular/platform-browser';
import {ActivePages} from '../../services/event-tracker/event-tracker.service';
import {Kpi} from '../../../models/common';
import {InfluencerService} from '../../services/influencer/influencer.service';
import {PlaceholderVisibilityService} from '../../services/placeholder-visibility/placeholder-visibility.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Conversation} from '../../../models/inbox';
import {CampaignService} from '../../services/campaign/campaign.service';
import {CommunicationService} from '../../services/communication/communication.service';
import {AchooPopupComponent} from '../../core/achoo-popup/achoo-popup.component';
import {ModalService} from '../../services/modal/modal.service';
import {Subscription} from 'rxjs/Subscription';
import {PdfExportService} from '../../services/export-pdf/pdf-export.service';
import {PdfViewerService} from '../../main/pdf-viewer/pdf-viewer.service';
import {AppSettings} from '../../utils/app-settings';

enum InfluencerTab {
  CAMPAIGN = 1,
  CHAT = 2
}

@Component({
  selector: 'app-influencer-campaign-detail',
  templateUrl: './influencer-campaign-detail.component.html',
  styleUrls: ['./influencer-campaign-detail.component.scss']
})
export class InfluencerCampaignDetailComponent implements OnInit, OnDestroy {
  @ViewChild('AlertPdfDownloadPending')
  public alertPdfDownloadPending: AchooPopupComponent;
  public influencerId: number;
  // keep id to back to campaign list
  public selectedCampaign: any;
  public preSelectedInfluencerId: number;

  public selectedCampaignId: number;
  public campaignList: any[];
  public activeBottomBar: boolean;

  public activeTabIndex: number | 1;
  public target: string;
  public campaignSilder: InfluencerCampaignStatus[];
  public campaignInfluencerKPI: Kpi | null;
  public campaignPosts: InfluencerCampaignPost[];
  public campaignKeywords: Array<string>;

  public conversation: Conversation;
  public showActivityLog = true;

  // pdf subscription
  private exportPdfSubcription: Subscription;

  constructor(private influencerService: InfluencerService,
              private placeholderService: PlaceholderVisibilityService,
              private route: ActivatedRoute,
              private router: Router,
              protected userService: UserService,
              private modalService: ModalService,
              private pdfService: PdfExportService,
              private pdfViewerService: PdfViewerService,
              public campaignService: CampaignService,
              private communicationService: CommunicationService,
              private title: Title) {

    this.campaignSilder = [
      {i: 0, value: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.DECLINED.value, name: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.DECLINED.name, selected: false},

      {i: 1, value: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.INVITED.value, name: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.INVITED.name, selected: false},

      {i: 2, value: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACTIVE.value, name: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACTIVE.name, selected: false},

      {i: 3, value: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.PUBLISHED.value, name: CommonConstant.CAMPAIGN_INFLUENCER_STATUS.PUBLISHED.name, selected: false}
    ];
  }

  ngOnInit() {
    this.activeTabIndex = InfluencerTab.CAMPAIGN;
    this.route.params.subscribe(params => {
      this.preSelectedInfluencerId = params.campaignId;
    });
    this.loadDetailsCampaignInfluencer(this.preSelectedInfluencerId);
  }

  ngOnDestroy() {
    if (this.exportPdfSubcription) {
      this.exportPdfSubcription.unsubscribe();
    }
  }

  private loadInfluencerConversation(campaignCompany: number, influencerId: number) {
    this.communicationService.fetchInfluencerConversation(campaignCompany, influencerId).subscribe((res) => {
      this.conversation = res;
    });
  }

  changeStatus(event) {}

  public onChangeCampaign(e) {
    this.loadDetailsCampaignInfluencer(e.campaignInfluencerId);
  }

  public setChatTabSelected() {
    this.activeTabIndex = InfluencerTab.CHAT;
  }

  private loadDetailsCampaignInfluencer(campaignInfluencerId) {
    const currentInfluencer = this.userService.getInfluencerInfo();
    this.influencerId = currentInfluencer.id;
    this.getCampaignBelongedToInfluencer(currentInfluencer.id, campaignInfluencerId);
  }

  private getCampaignInfluencerDetail(campaignInfluencerId: number) {
    this.influencerService.getCampaignInfluencerDetail(campaignInfluencerId).subscribe((res: any) => {
      if (res && res.campaign) {
        this.selectedCampaign = res.campaign;
        this.campaignKeywords = res.campaign.projectKeywords.map(pk => pk.keyword.keyword);
        // Should load actual message here
        this.loadInfluencerConversation(this.selectedCampaign.company_id, this.influencerId);
      }
    });
  }
  private getCampaignBelongedToInfluencer(influencerId, selectedCampaignInfluencerId) {
    // get campaign list of influencer
    const params = {
      influencer_id: influencerId,
      page: CommonConstant.START_PAGE_INDEX,
      page_size: 50
    };
    this.influencerService.getCampaignListOfInfluencer(params)
      .subscribe((res: any) => {
        this.campaignList = res.filter(cp => this.isConfirmedCampaign(cp));
        if (!Array.isArray(this.campaignList) || this.campaignList.length === 0) {
          return;
        }
        let selectedCampaign;
        if (selectedCampaignInfluencerId) {
          selectedCampaign = this.campaignList.find(item => item.campaignInfluencerId === Number(selectedCampaignInfluencerId));
        }
        if (selectedCampaign) {
          this.selectedCampaignId = selectedCampaign.id;
          this.getCampaignInfluencerData(selectedCampaign.campaignInfluencerId);
          this.getCampaignInfluencerDetail(selectedCampaign.campaignInfluencerId);
        } else {
          this.router.navigate(['dashboard', 'campaigns']);
        }
      });
  }

  private isActiveCampaign(cp) {
    if (!cp || !cp.status) {
      return false;
    }
    return cp.status === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACTIVE.name.toLowerCase()
      || cp.status === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACCEPTED.name.toLowerCase()
      || cp.status === CommonConstant.CAMPAIGN_INFLUENCER_STATUS.PUBLISHED.name.toLowerCase();
  }

  /**
   * A campaign which has been reviewed by influencer
   * @param cp
   * @returns {boolean}
   */
  private isConfirmedCampaign(cp) {
    if (!cp || !cp.status) {
      return false;
    }
    return cp.status !== CommonConstant.CAMPAIGN_INFLUENCER_STATUS.INVITED.name.toLowerCase()
      && cp.status !== CommonConstant.CAMPAIGN_INFLUENCER_STATUS.INTERESTED.name.toLowerCase();
  }

  private getCampaignInfluencerData(campaignInfluencerId: number) {
    this.placeholderService.show(CommonConstant.INFLUENCER_CAMPAIGN_DETAILS_HOLDER);
    this.influencerService.getCampaignInfluencerData(campaignInfluencerId)
      .subscribe((res) => {
        // parse KPI
        const postKpi = new Kpi();
        postKpi.engagement.value = res.globalKpi.engagement;
        postKpi.impact.value = res.globalKpi.impact * 100;
        postKpi.impressions.value = res.globalKpi.impression;
        postKpi.reach.value = res.globalKpi.reach;
        postKpi.post.value = res.globalKpi.post;
        this.campaignInfluencerKPI = postKpi;
        // parse post list
        const postList = res.postList.map(post => ({
          imageUrl: post.image,
          title: post.page_title,
          date: post.date,
          relativePath: post.relativePath,
          fullUrl: post.full_url,
          platformBlogs: post.platformBlogs,
          platformInstagram: post.platformInstagram,
          platformYoutube: post.platformYoutube,
          platformSnapchat: post.platformSnapchat,
          platformTwitter: post.platformTwitter,
          platformPinterest: post.platformPinterest,
          platformFacebook: post.platformFacebook,
          platformTiktok: post.platformTiktok,
          reach: post.reach.value,
          engagement: post.engagement.value,
          impressions: post.impression && post.impression.value > 0 ? post.impression.value : post.reach.value,
          impact: post.impact.value,
          urlHash: post.urlHash
        }));
        this.campaignPosts = postList;
        this.updateSlider(res.campaign.status);
        this.placeholderService.hide(CommonConstant.INFLUENCER_CAMPAIGN_DETAILS_HOLDER);
      });
  }

  private updateSlider(status) {
    let normalizedStatus = status;
    if (this.isActiveCampaign({ status: status.toLowerCase() })) {
      normalizedStatus = CommonConstant.CAMPAIGN_INFLUENCER_STATUS.ACTIVE.name;
    }
    this.campaignSilder = this.campaignSilder.slice(0); // clone new slider
    this.campaignSilder.forEach(item => {
      if (item.name === normalizedStatus) {
        item.selected = true;
      } else {
        item.selected = false;
      }
    });
  }

  get platformBackground() {
    return this.userService.platformBackground;
  }

  private getActivePageType(activeTabIndex: number): string {
    switch (activeTabIndex) {
      case InfluencerTab.CAMPAIGN: {
        return ActivePages.INFLUENCER_CAMPAIGNS;
      }
      default:
        return ActivePages.INFLUENCER_OVERVIEW;
    }
  }

  showCampaign() {
    this.activeTabIndex = InfluencerTab.CAMPAIGN;
  }

  get campaignActionData() {
    return {};
  }

  get isActiveCampaignTab() {
    return this.activeTabIndex === InfluencerTab.CAMPAIGN;
  }

  get isActiveChatTab() {
    return this.activeTabIndex === InfluencerTab.CHAT;
  }

  isAcivatedAdvertiserChat() {
    return !AppSettings.isDisableChat();
  }

  backToCampaignOverview() {
    this.router.navigate(['/dashboard/campaigns']);
  }

  exportPDF() {
    this.modalService.open(this.alertPdfDownloadPending, null, true, CommonConstant.PDF_EXPORT_NOTIFICATION_SHOWING_TIME);
    this.exportPdfSubcription = this.pdfViewerService.generateCampaignPdf(this.preSelectedInfluencerId).subscribe();
  }

  closeNotification() {
    this.modalService.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-campaign-detail/influencer-campaign-detail.component.ts